export default __webpack_public_path__ + "static/media/show-pruner-2.102b7b98.webp";